import { createContext } from 'react';
import {
  Accountant,
  User,
  UserPreferences,
  ViewSelectProp,
} from '../../models/User';
import utils from 'utils';
import { Listing } from 'models/Listing';
import { DropzoneDelete, DropzoneUpload } from 'models/Dropzone';
import { Enterprise, EnterpriseMember } from 'models/Enterprises';
import { UpdatePasswordValues } from 'router/subrouters/Dash/subrouters/private/subrouters/Profile/hooks/useProfileForm';

export type CallbackConfig = {
  skipToast?: boolean;
  onSuccess?: () => void;
  onError?: () => void;
};

type CurrentUserContextProps = {
  currentUser: User;
  isUserVerified: boolean;
  isSuperAdmin: boolean;
  isUltraAdmin: boolean;
  hasEnterprise: boolean;
  isEnterpriseHead: boolean;
  isOfficeManager: boolean;
  isRWCMember: boolean;
  enterpriseMember: EnterpriseMember;
  enterprise: Enterprise;
  hasEnterpriseLogo: boolean;
  openVerificationModal: (
    shouldCheckPhone?: boolean,
    listingId?: string,
  ) => void;
  openPhoneVerificationModal: () => void;
  patchCurrentUser: (
    user: Partial<User>,
    config?: CallbackConfig,
  ) => Promise<void>;
  updatePreferences: (preferences: Partial<UserPreferences>) => void;
  markSessionRead: (sessionId: string) => void;
  markSessionUnread: (sessionId: string) => void;
  uploadProfileImage: DropzoneUpload;
  deleteProfileImage: DropzoneDelete;
  setCurrentUser: React.Dispatch<React.SetStateAction<User>>;
  isListingEnquirableAndWatchableByMe: (listing: Listing) => [boolean, boolean];
  updateAccountants: (accountant: Partial<Accountant>) => void;
  changePassword: (
    value: UpdatePasswordValues,
    config?: CallbackConfig,
  ) => Promise<void>;
  updateView: (key: ViewSelectProp, value: boolean) => void;
};

export default createContext<Partial<CurrentUserContextProps>>({
  currentUser: null,
  isUserVerified: false,
  isSuperAdmin: false,
  isUltraAdmin: false,
  hasEnterprise: false,
  isEnterpriseHead: false,
  isOfficeManager: false,
  isRWCMember: false,
  enterpriseMember: null,
  enterprise: null,
  hasEnterpriseLogo: false,
  openVerificationModal: utils.noop,
  openPhoneVerificationModal: utils.noop,
  changePassword: utils.noop,
  patchCurrentUser: utils.noop,
  updatePreferences: utils.noop,
  uploadProfileImage: utils.noop,
  deleteProfileImage: utils.noop,
  markSessionRead: utils.noop,
  markSessionUnread: utils.noop,
  setCurrentUser: utils.noop,
  isListingEnquirableAndWatchableByMe: utils.noop,
  updateAccountants: utils.noop,
  updateView: utils.noop,
});
